<template>
    <div class="co2concentration">
        <table>
            <tr>
                <td class="left">
                    <label >CO<sub>2</sub> {{type}}</label>
                </td>

                <td class="result">
                    <label >{{concentration}} {{units}}</label>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
  /* eslint-disable */
    name: 'co2concentration',
    props: {
        unit: String,
        triggerprop: Number,
        obj: Object
    },
    data: () => ({
        concentration: 0,
        units: "\u03BCmol",
        unitsco2: [
            "\u03BCmol/L",
            "mm Hg",
            "mBar",
            "%",
            "ppm (vol/vol)",
            "ppm (mg/L)"
        ],
        type: "Concentration:"
    }),
    methods: {
        calculate() {
          var temp
          var pressure
          var sal
          var gasconc
          var conc
          if (this.obj.tempType === "Kelvin") {
              temp = Number(this.obj.temp) - 273.15
          } else {
              temp = Number(this.obj.temp)
          }

          sal = Number(this.obj.salinity)
          pressure = Number(this.obj.pressure)
          gasconc = Number(this.obj.gasConcentration)

          switch(this.unit) {
            case "\u03BCmol/L":
                this.units = "\u03BCmol/L"
                conc = this.umolL(temp,sal,pressure,gasconc)
                this.type = "Concentration:"
                break;
            case "mm Hg":
                this.units = "mm Hg"
                conc = this.mmHg(temp,sal,pressure,gasconc)
                this.type = "Partial Pressure:"
                break;
            case "%":
                this.units = "%"
                conc = this.saturation(temp,sal,pressure, gasconc)
                this.type = "Concentration:"
                break;
            case "mBar":
                this.units = "mBar"
                conc = this.mBar(temp,sal,pressure,gasconc)
                this.type = "Partial Pressure:"
                break;
            case "airsaturation":
                this.units = "%"
                conc = this.calculateairsaturation(temp, sal, pressure, gasconc)
                this.type = "Concentration:"
                break;
            case "ppm (vol/vol)":
                this.units = "ppm (vol/vol)"
                conc = this.ppm(temp,sal,pressure,gasconc)
                this.type = "Concentration:"
                break;
            case "ppm (mg/L)":
                this.units = "ppm (mg/L)"
                conc = this.ppmmgL(temp,sal,pressure,gasconc)
                this.type = "Concentration:"
                break;
            default:
                this.units = "N/A"
                conc = 0
                this.type = ""
                break;
          }
          this.concentration = conc.toPrecision(6)
      },
      K(temp,sal){
        var T0 = 273.15
        var A1 = -58.0931
        var A2 = 90.5069
        var A3 = 22.294
        var B1 = 0.027766
        var B2 = -0.025888
        var B3 = 0.0050578
        var T = (T0+temp)/100
        var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
        var ptable = 1 * (1013.25 - p_sat)
        var t = Math.exp(A1+A2*(1/T)+A3*Math.log(T)+sal*(B1+B2*T+B3*Math.pow(T,2))) *1000000
        return t/ptable
      },
      umolL(temp, sal, pressure, gasconc){
        switch(this.obj.unitIn){
          case "\u03BCmol/L":
            return gasconc
          case "ppm (mg/L)":
            return gasconc*1000/44.01
          case "mm Hg":
            return this.K(temp,sal)*gasconc/0.750061683
          case "%":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = (pressure - p_sat) * gasconc / 100
            return partpres*this.K(temp,sal)
          case "mBar":
            return this.K(temp,sal)*gasconc
          case "ppm (vol/vol)":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = (pressure - p_sat) * gasconc / 1000000
            return partpres*this.K(temp,sal)
        }
      },
      mmHg(temp, sal, pressure, gasconc){
        switch(this.obj.unitIn){
          case "\u03BCmol/L":
            return gasconc/this.K(temp,sal)*0.750061683
          case "ppm (mg/L)":
            var conc = gasconc*1000/44.01
            return conc/this.K(temp,sal)*0.750061683
          case "mm Hg":
            return gasconc
          case "%":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = (pressure - p_sat) * gasconc / 100
            return partpres*0.750061683
          case "mBar":
            return gasconc * 0.750061683
          case "ppm (vol/vol)":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = (pressure - p_sat) * gasconc / 1000000
            return partpres*0.750061683
        }
      },
      saturation(temp, sal, pressure, gasconc){
        switch(this.obj.unitIn){
          case "\u03BCmol/L":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = gasconc/this.K(temp,sal)
            return partpres*100/(pressure - p_sat)
          case "ppm (mg/L)":
            var conc = gasconc*100/44.01
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = conc/this.K(temp,sal)
            return partpres*1000/(pressure - p_sat)
          case "mm Hg":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            return gasconc/0.750061683*100/(pressure - p_sat)
          case "%":
            return gasconc
          case "mBar":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = gasconc/this.K(temp,sal)
            return gasconc*100/(pressure - p_sat)
          case "ppm (vol/vol)":
            return gasconc/10000
        }
      },
      mBar(temp, sal, pressure, gasconc){
        switch(this.obj.unitIn){
          case "\u03BCmol/L":
            return gasconc/this.K(temp,sal)
          case "ppm (mg/L)":
            var conc = gasconc*1000/44.01
            return conc/this.K(temp,sal)
          case "mm Hg":
            return gasconc/0.750061683
          case "%":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = (pressure - p_sat) * gasconc / 100
            return partpres
          case "mBar":
            return gasconc
          case "ppm (vol/vol)":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = (pressure - p_sat) * gasconc / 1000000
            return partpres
        }
      },
      ppm(temp, sal, pressure, gasconc){
        switch(this.obj.unitIn){
          case "\u03BCmol/L":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = gasconc/this.K(temp,sal)
            return partpres*1000000/(pressure - p_sat)
          case "ppm (mg/L)":
            var conc = gasconc*1000/44.01
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = conc/this.K(temp,sal)
            return partpres*1000000/(pressure - p_sat)
          case "mm Hg":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            return gasconc/0.750061683*1000000/(pressure - p_sat)
          case "%":
            return gasconc*10000
          case "mBar":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = gasconc/this.K(temp,sal)
            return gasconc*1000000/(pressure - p_sat)
          case "ppm (vol/vol)":
            return gasconc
        }
      },
      ppmmgL(temp, sal, pressure, gasconc){
        switch(this.obj.unitIn){
          case "\u03BCmol/L":
            return gasconc*44.01/1000
          case "ppm (mg/L)":
            return gasconc
          case "mm Hg":
            return this.K(temp,sal)*gasconc/0.750061683*44.01/1000
          case "%":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = (pressure - p_sat) * gasconc / 100
            return partpres*this.K(temp,sal)*44.01/1000
          case "mBar":
            return this.K(temp,sal)*gasconc*44.01/1000
          case "ppm (vol/vol)":
            var T0 = 273.15
            var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
            var partpres = (pressure - p_sat) * gasconc / 1000000
            return partpres*this.K(temp,sal)*44.01/1000
        }
      }
    },
    mounted() {
        this.calculate()
    },
    watch: {
        triggerprop: function(newval, oldval) {
            this.calculate()
        }
    }
}
</script>
